// extracted by mini-css-extract-plugin
export default {"container":"StagesLegend_container__O06p+","stage":"StagesLegend_stage__-zAii"};